import { useEffect } from "react";
import { useCloud } from "./useCloud";
import store from "../store/index"; // Adjust the path as necessary
import useOrder from "./useOrder";
import useNotifications from "./useNotifications";
import { transformDigitalOrderItems } from "../utils/common";
import { SUCCESS } from "../assets/constants";
export const useStore = () => {
  const { processOrder, getLatestBillNumber } = useOrder();
  const { registerToken } = useNotifications();
  const {
    getAllItems,
    allCategories,
    tableData,
    getTableData,
    requestedKOTData,
    getWaiterList,
    getAllCategoryAndItem,
    getOrderHistory,
    getDigitalOrders,

    // V2
    getRestaurantInfo,
    getMenu,
    
  } = useCloud();

  const transformDigitalOrders = (order) => {
    const formatedOrder = order.items.map((newOrder) => ({
      itemId: newOrder.itemId,
      quantity: parseInt(newOrder.quantity),
      varientid:
        newOrder.variationId != "NA" ? newOrder.variationId : undefined,
    }));
    const items = transformDigitalOrderItems(order);
    const rawOrder = items.map((newOrder) => ({
      feUniqueItemId: newOrder.feUniqueItemId,
      itemId: newOrder.itemId,
      id: newOrder.id,
      name: newOrder.name,
      price: newOrder.price || "0",
      variant: newOrder.variant,
      quantity: parseInt(newOrder.quantity),
      variantId: newOrder.variantId,
      variantName: newOrder.variantName,
      isVariant: newOrder.isVariant,
      extra: false,
      createdAt: new Date(),
      readyAt: false,
    }));
    return {
      rawOrder,
      formatedOrder,
      tableVPA: order.tableVPA,
      cancleOrders: [],
      extraOrders: [],
      username: order.name,
      usermobile: order?.mobileNo || "NA",
      orderStatus: "RequestKOT",
      onlineBillNo: order.onlineCode,
      replaceItems: "RequestKOT",
      isOnline: true,
      orderComment: order.orderComment,
    };
  };

  const getCloudSync = async () => {
    try {
      registerToken();
      const restaurantInfo = await getRestaurantInfo();
      if (restaurantInfo && restaurantInfo.status === SUCCESS) {
        const {
          staff,
          rooms,
          gstRate,
          gstItemType,
          gstNumber,
          isGst,
          fassi_no,
          vat,
          ...info
        } = restaurantInfo.data;

        store.rooms = rooms;
        store.tables = rooms.reduce((acc, room) => {
          const tables = room.tables.map((table) => ({
            ...table,
            room: room.roomName,
          }));
          acc.push(...tables);
          return acc;
        }, []);

        store.staff = staff;

        store.GST = {
          rates: gstRate,
          gstType: gstItemType,
          gstNumber: gstNumber,
          active: isGst,
          fassi_no: fassi_no,
          vat,
        };
        store.restaurantInfo = info;
        store.isLoggedIn = true;
      }

      if (
        restaurantInfo.status !== SUCCESS &&
        restaurantInfo.errorMessage.message === "Unauthorized" &&
        window.location.pathname !== "/login"
      ) {
        window.location.replace("/login");
      }
      store.appBooting = false;
    } catch (err) {
      console.error("Failed to fetch data:", err);
    }
  };


  

  useEffect(() => {
    const fetchOnline = async () => {
      await getCloudSync();
    };
    fetchOnline();
  }, []);

  return { store, getCloudSync };
};

export default useStore;
